import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import router from './router'
import videoModalPlugin from './plugins/videoModal'

createApp(App).use(router).use(videoModalPlugin).mount('#app') 